import { useState, useEffect } from 'react'

import { gql, useQuery } from '@apollo/client';


const ENV_MAP_US = gql`
query query1 {
  environment(where: {id: {_gt: 0}}) {
    id
    name
  }
}
`

const ENV_MAP_EU = gql`
query query1 {
  environment(where: {id: {_gt: -1}}) {
    id
    name
  }
}
`

// Sub-environments (e.g. int-dev-cert-fi) have their own nodes in Chef/ZK, but their
// TTUS connections and companies belong to the parent env (int-dev-cert).
// Add a suffix here to map another family of sub-environments to their parent.
const SUB_ENV_SUFFIXES = ['-fi']

export const getConnectionEnv = (env) => {
    const suffix = env && SUB_ENV_SUFFIXES.find(s => env.endsWith(s))
    return suffix ? env.slice(0, -suffix.length) : env
}

// This function is used to get the environment ID map from the backend
// EU and US backend will have different IDs for the same environment
// Due to the nature of the apollo cache we need to do 2 "different" queries to get this to work
// Even fetchPolicy: "no-cache" doesnt work. This is a workaround
// We only need to do this when we query from 2 backends at the same time and expect different results, which is rare

export const useEnvIDMap = (backend) => {

    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery((backend === "us" ? ENV_MAP_US : ENV_MAP_EU), { context: { backend: backend } })

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.environment.reduce((acc, d) => {
                if (d)
                    acc[d.name] = d.id
                return acc
            }, {}))
        }
    }, [data, loading])

    return lookupData
}